import React from 'react';
import { BiTachometer } from 'react-icons/bi';

import { Icon } from '@/components/icon/icon';
import {
  METRIC_TYPES,
  MetricConfigAPI,
  MetricConfigLLMScore,
  MetricTypeEnum
} from '@/types/evals';

/**
 * Derives the human-readable metric type from a config's `configuration` shape.
 * API classifiers carry a `url`; everything else is an LLM-as-a-Judge metric.
 */
export const getMetricType = (
  configuration: MetricConfigAPI | MetricConfigLLMScore
): MetricTypeEnum => (
  'url' in configuration ? METRIC_TYPES.API_CLASSIFIER : METRIC_TYPES.LLM_AS_A_JUDGE
);

/** Framed icon shown beside the metric title, matching the evals nav icon. */
export const getMetricIcon = (): React.ReactElement => <Icon icon={ BiTachometer } />;
